import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { func } from 'prop-types'
import { useForm } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import useContact from '@hooks/useContact'
import useLoading from '@hooks/useLoading'
import useDynamicFields from '@hooks/useDynamicFields'
import useInternationalization from '@hooks/useInternationalization'

import DynamicForm from '@components/DynamicForm'

import useValidation from '@hooks/useFormValidation'

import * as Style from './Form.style'

export default function Form({ onSubmit }) {
  const { states } = useSelector(store => store.country)

  const { fields: companyInfoFields } = useDynamicFields('brokerCompanyInfo')
  const { fields: brokerInfoFields } = useDynamicFields('brokerInfo')

  const [disabledField, setDisabledField] = useState({})

  const { contact } = useContact()
  const { isLoading } = useLoading()

  const { country } = useInternationalization()

  const validationSchema = useValidation(
    companyInfoFields.concat(brokerInfoFields)
  )

  const { register, errors, handleSubmit, control } = useForm({
    defaultValues: { ...contact },
    validationSchema,
  })

  const companyInfoFieldsWithItems = companyInfoFields.map(field => {
    return field.id === 'state'
      ? {
          ...field,
          items: {
            defaultElements: {
              elements: states,
            },
          },
        }
      : field
  })

  useEffect(() => {
    if (contact) {
      setDisabledField({
        email: !!contact.email,
        brokerEmail: !!contact.brokerEmail,
      })
    }
  }, [contact && contact.email])

  return (
    <Style.FormWrapper id="company-info-form">
      <Style.Fieldset>
        <Style.FormTitle>
          <FormattedMessage id="smb_acquisition_broker_company_info.page.broker_section.title" />
        </Style.FormTitle>
        <DynamicForm
          fields={brokerInfoFields}
          register={register}
          disabledFields={disabledField}
          errors={errors}
          control={control}
        />
      </Style.Fieldset>
      <Style.Fieldset>
        <Style.FormTitle>
          <FormattedMessage id="smb_acquisition_broker_company_info.page.company_section.title" />
        </Style.FormTitle>
        <Style.FormSubtitle>
          <FormattedMessage id="smb_acquisition_broker_company_info.page.company_section.subtitle" />
        </Style.FormSubtitle>
        <DynamicForm
          fields={companyInfoFieldsWithItems}
          register={register}
          disabledFields={disabledField}
          errors={errors}
          control={control}
        />
      </Style.Fieldset>
      <Row>
        <Col xxs={12}>
          <section>
            <Style.PrivacyPolicy>
              <FormattedMessage
                id="smb_acquisition_broker_company_info.page.warnings.privacy_policy"
                values={{
                  a: (...chunks) => (
                    <a href={`https://www.gympass.com/${country}/privacy`}>
                      {chunks}
                    </a>
                  ),
                }}
              />
            </Style.PrivacyPolicy>
          </section>
        </Col>
      </Row>

      <Row>
        <Col xxs={12} md-start={5} md={4} xl-start={4} xl={6}>
          <Style.ButtonWrapper>
            <Style.Button
              full
              loading={isLoading}
              onClick={handleSubmit(onSubmit)}
            >
              <Style.ButtonText>
                <FormattedMessage id="smb_acquisition_company_info.page.lead_capture.call_to_action" />
              </Style.ButtonText>
            </Style.Button>
          </Style.ButtonWrapper>
        </Col>
      </Row>
    </Style.FormWrapper>
  )
}
Form.propTypes = {
  onSubmit: func.isRequired,
}
